import { render, staticRenderFns } from "./AccountCreate.vue?vue&type=template&id=70094e60&scoped=true&"
import script from "./AccountCreate.vue?vue&type=script&lang=js&"
export * from "./AccountCreate.vue?vue&type=script&lang=js&"
import style0 from "./AccountCreate.vue?vue&type=style&index=0&id=70094e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70094e60",
  null
  
)

export default component.exports